import { render, staticRenderFns } from "./SuperSyndicatePayouts.vue?vue&type=template&id=045d626f&scoped=true&"
import script from "./SuperSyndicatePayouts.vue?vue&type=script&lang=js&"
export * from "./SuperSyndicatePayouts.vue?vue&type=script&lang=js&"
import style0 from "./SuperSyndicatePayouts.vue?vue&type=style&index=0&id=045d626f&scoped=true&lang=css&"
import style1 from "./Styles/SuperSyndicate.css?vue&type=style&index=1&id=045d626f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d626f",
  null
  
)

export default component.exports